module.exports = ".page-content label {\n  margin-top: 0px !important;\n  text-transform: uppercase;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/donation/donation-info/donation.component.css
// module id = ./src/app/donation/donation-info/donation.component.css
// module chunks = main